<div class="modal fade coupon-generator-modal" id="appModal" #appModal tabindex="-1" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-body">
                <div class="container-fluid">
                    <div class="row">
                        <button class="close" data-dismiss="modal"></button>
                    </div>

                    <app-coupon-generate (closeModal)="onClosed($event)"></app-coupon-generate>

                </div>
            </div>
        </div>
    </div>
</div>